<template>
  <div class="row">
    <div class="container-fluid">
      <user-menu-actions  :disableButtons="isActionActive" />
      <user-menu-info-no-feeds v-if="this.noFeeds" />
    </div>
  </div>
</template>

<script>
import UserMenuActions from "./User.Menu.Actions.vue";
import UserMenuInfoNoFeeds from "@/components/User/User.Menu.InfoNoFeeds.vue";

export default {
  name: "User.Menu",
  components: {
    UserMenuActions,
    UserMenuInfoNoFeeds
  },
  data: function() {
    return {
      isActionActive: false,
      actionType: ""
    };
  },
  computed: {
    noFeeds() {
      return this.$store.state.UserFeeds.items.every(
        item => item.urls.length == 0
      );
    } 
  },
  methods: {
    onStopAction: function() {
      this.isActionActive = false;
      this.actionType = "";
      this.$emit("executeStop");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.no-mode-translate-fade-enter-active,
.no-mode-translate-fade-leave-active {
  transition: all 0.1s;
}
.no-mode-translate-fade-enter,
.no-mode-translate-fade-leave-active {
  opacity: 0;
}
.no-mode-translate-fade-enter {
  transform: translateX(31px);
}
.no-mode-translate-fade-leave-active {
  transform: translateX(-31px);
}

.in-out-translate-fade-enter-active,
.in-out-translate-fade-leave-active {
  transition: all 0.5s;
}
.in-out-translate-fade-enter,
.in-out-translate-fade-leave-active {
  opacity: 0;
}
.in-out-translate-fade-enter {
  transform: translateX(31px);
}
.in-out-translate-fade-leave-active {
  transform: translateX(-31px);
}

.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
</style>
